import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';
import { saveTokens, removeTokens } from '../../utils/tokenUtils';

// Login user
export const loginUser = createAsyncThunk(
    'auth/login',
    async (credentials, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/login', credentials);
            
            if (response.data.access_token && response.data.user) {
                const { access_token, refresh_token, user } = response.data;
                
                // Save tokens to localStorage
                saveTokens(access_token, refresh_token, user);
                
                return {
                    user,
                    accessToken: access_token,
                    refreshToken: refresh_token
                };
            } else {
                return rejectWithValue({
                    message: 'Invalid response format'
                });
            }
        } catch (error) {
            if (error.response?.data?.errors) {
                // Handle validation errors
                return rejectWithValue({
                    message: Object.values(error.response.data.errors).flat().join(', '),
                    errors: error.response.data.errors
                });
            }
            return rejectWithValue({
                message: error.response?.data?.message || 'Login failed'
            });
        }
    }
);

// Logout user
export const logoutUser = createAsyncThunk(
    'auth/logout',
    async (_, { rejectWithValue }) => {
        try {
            await axiosInstance.post('/logout');
            removeTokens();
            return null;
        } catch (error) {
            console.error('Logout error:', error);
            return rejectWithValue(error.response?.data || { message: 'Logout failed' });
        }
    }
); 